import React from 'react';
import { SmileIcon, CheckCircleIcon, NetworkIcon, ShieldCheckIcon } from 'lucide-react';
export function ImpactSection() {
  const impacts = [{
    icon: SmileIcon,
    title: 'Reducción del estrés familiar',
    description: 'Familias más tranquilas y empoderadas'
  }, {
    icon: CheckCircleIcon,
    title: 'Mayor adherencia a tratamientos',
    description: 'Mejores resultados a largo plazo'
  }, {
    icon: NetworkIcon,
    title: 'Mejor integración',
    description: 'Entre terapias, nutrición y hogar'
  }, {
    icon: ShieldCheckIcon,
    title: 'Prevención de condiciones crónicas',
    description: 'Intervención temprana y efectiva'
  }];
  return <section id="impacto" className="py-20 px-4 sm:px-6 lg:px-8" style={{
    background: 'linear-gradient(to bottom, #f0f9e8, #ffffff)'
  }} data-id="element-101">
      <div className="max-w-6xl mx-auto" data-id="element-102">
        <h2 className="text-3xl sm:text-4xl font-bold text-dark text-center mb-12" data-id="element-103">
          Nuestro Impacto
        </h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-12" data-id="element-104">
          {impacts.map((impact, index) => <div key={index} className="bg-white rounded-xl p-6 text-center shadow-md hover:shadow-xl hover:scale-[1.03] transition-all duration-300" data-id="element-105">
              <div className="inline-flex items-center justify-center w-14 h-14 bg-primary/10 rounded-full mb-4" data-id="element-106">
                <impact.icon className="w-7 h-7 text-primary" data-id="element-107" />
              </div>
              <h3 className="text-lg font-bold text-dark mb-2" data-id="element-108">
                {impact.title}
              </h3>
              <p className="text-sm text-gray-600" data-id="element-109">{impact.description}</p>
            </div>)}
        </div>
        <div className="max-w-3xl mx-auto mb-10" data-id="element-110">
          <img src="https://cdn.magicpatterns.com/uploads/aUg3Kejn6x6VgUNoJWjDsh/heylloyd-image-1782596170904.png" alt="Familia caminando unida hacia un nuevo camino" className="w-full h-72 object-cover rounded-2xl shadow-lg" data-id="element-111" />
        </div>
        <div className="bg-white/70 rounded-2xl p-8 border-l-4 border-primary shadow-md" data-id="element-112">
          <p className="text-xl italic text-dark text-center" data-id="element-113">
            "Cuando una familia entiende qué hacer, deja de sobrevivir y
            comienza a construir un nuevo camino"
          </p>
        </div>
      </div>
    </section>;
}